<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,2C9,2,9,3.08296,9,3.08296C11.83771,3.55904,14,6.027,14,9C14,12.3137,11.31371,15,8,15C4.68629,15,2,12.3137,2,9C2,6.027,4.1622900000000005,3.55904,7,3.08296C7,3.08296,7,2,7,2C7,2,6,2,6,2C5.44772,2,5,1.55228,5,1C5,0.447715,5.44772,1.01453e-16,6,1.40865e-32C6,1.40865e-32,10,1.40865e-32,10,1.40865e-32C10.55228,-1.01453e-16,11,0.447715,11,1C11,1.55228,10.55228,2,10,2C10,2,9,2,9,2C9,2,9,2,9,2ZM8,5C5.79086,5,4,6.79086,4,9C4,11.2091,5.79086,13,8,13C10.20914,13,12,11.2091,12,9C12,9,8,9,8,9C8,9,8,5,8,5C8,5,8,5,8,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Stopwatch',
} as DefineComponent
</script>
